<template>
    <AccidentDashboard></AccidentDashboard>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const AccidentDashboard = defineAsyncComponent(() =>
    import("../../components/Safety/AccidentDashboard/AccidentDashboard.vue")
);

export default {
    name: "Accident_Dashboard", //The name you are in should not equal the name of the component you are importing.
    components: { AccidentDashboard, AuthLayout },
};
</script>
